/* Assistant de clavardage Ornemoi (widget du thème).
   Source : Business/Ornemoi/assistant-clavardage/theme/assets/ornemoi-assistant.js
   Parle à la fonction serveur (window.OrnemoiAssistant.endpoint), exécute les changements de panier
   seulement après le clic « Confirmer » du client, et ouvre Shopify Inbox au transfert vers David. */
(function () {
  "use strict";
  var CFG = window.OrnemoiAssistant;
  if (!CFG || !CFG.endpoint || window.__oaLoaded) return;
  window.__oaLoaded = true;

  var FR = String(CFG.locale || document.documentElement.lang || "en").toLowerCase().indexOf("fr") === 0;
  var ROOT = CFG.root && CFG.root !== "/" ? CFG.root.replace(/\/$/, "") : "";
  // Page « Assistant de clavardage : vos renseignements » (Loi 25), créée le 24 oct. 2026.
  var PRIVACY_URL = ROOT === "/fr" ? "/fr/pages/assistant-clavardage-vos-renseignements" : ROOT + "/pages/chat-assistant-your-information";
  // Textes de l'interface. Ils suivent la langue de la page au départ, puis celle du CLIENT : si un client écrit
  // en français sur la page anglaise, le serveur renvoie lang="fr" et l'interface bascule (state.uiLang).
  var TEXTS = {};
  TEXTS.fr = {
        title: "Ornemoi",
        sub: "Assistant automatisé",
        open: "Ouvrir le clavardage",
        close: "Fermer",
        placeholder: "Écrivez votre message…",
        send: "Envoyer",
        hello:
          "Bonjour! Je suis l'assistant d'Ornemoi. Je peux répondre à vos questions et préparer votre panier avec les noms de votre choix. Au besoin, je vous mets en contact avec David, le propriétaire.",
        privacy: "Conversation conservée 30 jours, sans vos coordonnées, pour améliorer le service.",
        resumed: "Suite de votre conversation précédente",
        cart: "Voir le panier",
        viewCart: "Voir mon panier",
        checkout: "Passer à la caisse",
        cardTitle: "Je modifie votre panier :",
        confirm: "Confirmer",
        decline: "Non, modifier",
        confirmed: "Confirmé.",
        declined: "Pas de changement.",
        cartError: "Le panier n'a pas pu être modifié.",
        error: "Je n'arrive pas à répondre en ce moment. Vous pouvez réessayer dans un instant, ou écrire directement à David.",
        tooMany: "Beaucoup de messages en peu de temps : réessayez dans quelques minutes.",
        humanTitle: "Conversation transférée à David",
        talk: "Écrire à David",
        teaserTitle: "Une question?",
        teaserText: "Je peux vous aider à choisir vos ornements et préparer votre panier. Je peux aussi vous mettre en contact avec David, le propriétaire, au besoin.",
      };
  TEXTS.en = {
        title: "Ornemoi",
        sub: "Automated assistant",
        open: "Open chat",
        close: "Close",
        placeholder: "Type your message…",
        send: "Send",
        hello:
          "Hi! I'm Ornemoi's assistant. I can answer your questions and set up your cart with the names you want. If needed, I'll connect you with David, the owner.",
        privacy: "This conversation is kept for 30 days, without your contact details, to improve our service.",
        resumed: "Continuing your previous conversation",
        cart: "View cart",
        viewCart: "View my cart",
        checkout: "Check out",
        cardTitle: "I'll update your cart:",
        confirm: "Confirm",
        decline: "No, change it",
        confirmed: "Confirmed.",
        declined: "No change made.",
        cartError: "The cart could not be updated.",
        error: "I can't answer right now. You can try again in a moment, or message David directly.",
        tooMany: "Lots of messages in a short time: please try again in a few minutes.",
        humanTitle: "Conversation handed over to David",
        talk: "Message David",
        teaserTitle: "Questions?",
        teaserText: "I can help you choose your ornaments and set up your cart. I can also connect you with David, the owner, if needed.",
      };

  // --- Stockage (tout peut échouer en navigation privée : on continue sans) ---
  function load(store, key) {
    try {
      var v = window[store].getItem(key);
      return v ? JSON.parse(v) : null;
    } catch (e) {
      return null;
    }
  }
  function save(store, key, value) {
    try {
      window[store].setItem(key, JSON.stringify(value));
    } catch (e) {}
  }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return "v-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 12);
  }

  var visitorId = load("localStorage", "oa-visitor");
  if (!visitorId) {
    visitorId = uuid();
    save("localStorage", "oa-visitor", visitorId);
  }
  // État de la conversation, gardé 7 jours après le dernier message (le serveur garde la sienne aussi longtemps) :
  // un client qui revient le lendemain reprend où il était. sessionStorage = ancien emplacement (avant le 30 oct.).
  var KEEP_MS = 7 * 24 * 60 * 60 * 1000;
  function freshState() {
    return { conversationId: null, log: [], pending: null, handedOff: false, open: false };
  }
  var state = load("localStorage", "oa-state");
  if (!state || !(Date.now() - state.lastAt < KEEP_MS)) state = load("sessionStorage", "oa-state") || freshState();
  if (!state.lastAt) state.lastAt = Date.now(); // lastAt = dernière réponse du serveur, pas la dernière page vue
  // Nouvelle visite : une conversation transférée à David repart à neuf (sinon l'assistant resterait caché);
  // les autres reprennent, fermées, et la carte de confirmation laissée ouverte est retirée (le panier a pu changer).
  var newVisit = !load("sessionStorage", "oa-visit");
  save("sessionStorage", "oa-visit", 1);
  if (newVisit && state.handedOff) state = freshState();
  var T = TEXTS[state.uiLang === "fr" || state.uiLang === "en" ? state.uiLang : FR ? "fr" : "en"];
  if (newVisit && state.log.length) {
    if (state.pending) state.log.push({ k: "card", p: state.pending, done: true });
    state.pending = null;
    state.open = false;
    var last = state.log[state.log.length - 1];
    if (!(last.k === "note" && last.t === T.resumed)) state.log.push({ k: "note", t: T.resumed });
  }
  function persist() {
    if (state.log.length > 80) state.log = state.log.slice(-80);
    save("localStorage", "oa-state", state);
  }
  persist();

  // --- Mise en forme des réponses : texte échappé, puis gras, listes, liens internes, photos du CDN Shopify ---
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function safeImage(url) {
    return /^https:\/\/cdn\.shopify\.com\/[^\s"'<>]+$/.test(url);
  }
  function safeLink(url) {
    return /^\/(?!\/)[^\s"'<>]*$/.test(url) || /^https:\/\/(www\.)?ornemoi\.(ca|shop)(\/[^\s"'<>]*)?$/.test(url);
  }
  function inline(text) {
    var out = esc(text);
    out = out.replace(/!\[([^\]]*)\]\(([^)\s]+)\)/g, function (m, alt, url) {
      var u = url.replace(/&amp;/g, "&");
      return safeImage(u) ? '<img src="' + esc(u) + '" alt="' + alt + '" loading="lazy">' : "";
    });
    out = out.replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, function (m, label, url) {
      var u = url.replace(/&amp;/g, "&");
      return safeLink(u) ? '<a href="' + esc(u) + '">' + label + "</a>" : label;
    });
    out = out.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
    return out;
  }
  function render(text) {
    var blocks = String(text || "").split(/\n{2,}/);
    return blocks
      .map(function (block) {
        var lines = block.split("\n");
        if (lines.every(function (l) { return /^\s*[-•]\s+/.test(l); })) {
          return "<ul>" + lines.map(function (l) { return "<li>" + inline(l.replace(/^\s*[-•]\s+/, "")) + "</li>"; }).join("") + "</ul>";
        }
        return "<p>" + lines.map(inline).join("<br>") + "</p>";
      })
      .join("");
  }

  // --- Interface ---
  var root = document.createElement("div");
  root.className = "oa-root";
  root.innerHTML =
    '<div class="oa-panel" role="dialog" aria-label="' + esc(T.title) + '">' +
    '<div class="oa-header"><div class="oa-header-title">' + esc(T.title) + '<span class="oa-header-sub">' + esc(T.sub) + "</span></div>" +
    '<button type="button" class="oa-close" aria-label="' + esc(T.close) + '">&times;</button></div>' +
    '<div class="oa-messages" aria-live="polite"></div>' +
    '<div class="oa-footer"><a class="oa-cart-link" href="' + esc(CFG.cartUrl || ROOT + "/cart") + '">' + esc(T.cart) + "</a>" +
    '<form class="oa-form"><label class="oa-visually-hidden" for="oa-input">' + esc(T.placeholder) + "</label>" +
    '<textarea id="oa-input" class="oa-input" rows="1" maxlength="800" placeholder="' + esc(T.placeholder) + '"></textarea>' +
    '<button type="submit" class="oa-send" aria-label="' + esc(T.send) + '"><svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M3.4 20.4 21 12 3.4 3.6 3.4 10l12.6 2-12.6 2z"/></svg></button></form>' +
    '<div class="oa-privacy"><a class="oa-privacy-link" target="_blank" rel="noopener" href="' + esc(PRIVACY_URL) + '">' + esc(T.privacy) + "</a></div></div></div>" +
    '<button type="button" class="oa-launcher" aria-label="' + esc(T.open) + '" aria-expanded="false">' +
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 3C6.5 3 2 6.6 2 11c0 2.4 1.3 4.6 3.4 6.1L4.5 21l4.2-2.2c1 .3 2.1.4 3.3.4 5.5 0 10-3.6 10-8s-4.5-8.2-10-8.2z"/></svg></button>';

  var panel = root.querySelector(".oa-panel");
  var list = root.querySelector(".oa-messages");
  var form = root.querySelector(".oa-form");
  var input = root.querySelector(".oa-input");
  var sendBtn = root.querySelector(".oa-send");
  var launcher = root.querySelector(".oa-launcher");
  var busy = false;

  function scrollDown() {
    list.scrollTop = list.scrollHeight;
  }
  function addBubble(kind, html) {
    var div = document.createElement("div");
    div.className = "oa-msg " + (kind === "user" ? "oa-user" : "oa-bot");
    div.innerHTML = html;
    list.appendChild(div);
    reveal(div, kind);
    return div;
  }
  function addNote(text) {
    var div = document.createElement("div");
    div.className = "oa-note";
    div.textContent = text;
    list.appendChild(div);
    reveal(div, "note");
  }
  // Défilement (choix de David) : on descend le plus bas possible SANS faire sortir par le haut le dernier
  // message du client. Réponse courte : tout est visible, boutons compris. Réponse longue : le message du
  // client reste en haut et la réponse se lit à partir de son début.
  var anchorEl = null;
  var anchorAt = 0;
  function settle() {
    var bottom = list.scrollHeight - list.clientHeight;
    var target = anchorEl ? Math.min(bottom, anchorEl.offsetTop - 8) : bottom;
    list.scrollTop = Math.max(0, target);
  }
  function setAnchor(el) {
    anchorEl = el;
    anchorAt = Date.now();
  }
  function reveal(el, kind) {
    if (kind === "user") setAnchor(el);
    settle();
    // Les photos grandissent en se chargeant : on réajuste, tant que la réponse est récente.
    Array.prototype.forEach.call(el.querySelectorAll ? el.querySelectorAll("img") : [], function (img) {
      img.addEventListener("load", function () {
        if (Date.now() - anchorAt < 10000) settle();
      });
    });
  }
  function logAndShow(kind, text) {
    state.log.push({ k: kind, t: text });
    persist();
    if (kind === "note") addNote(text);
    else addBubble(kind, kind === "user" ? esc(text).replace(/\n/g, "<br>") : render(text));
  }

  function setOpen(open) {
    state.open = open;
    persist();
    root.classList.toggle("oa-open", open);
    launcher.setAttribute("aria-expanded", open ? "true" : "false");
    if (open) {
      setTimeout(function () {
        input.focus();
      }, 50);
      scrollDown();
    }
  }
  launcher.addEventListener("click", function () {
    setOpen(!root.classList.contains("oa-open"));
  });
  root.querySelector(".oa-close").addEventListener("click", function () {
    setOpen(false);
  });
  // Vers le panier ou la caisse : la fenêtre se ferme, sinon elle se rouvre plein écran sur téléphone
  // et cache le panier. La conversation reste là, au clic sur la bulle.
  root.addEventListener("click", function (e) {
    if (e.target.closest && e.target.closest(".oa-card-cart a, .oa-cart-link")) setOpen(false);
  });
  list.addEventListener("click", function (e) {
    var img = e.target.closest && e.target.closest(".oa-msg img");
    if (!img) return;
    var zoom = document.createElement("div");
    zoom.className = "oa-zoom";
    zoom.innerHTML = '<img src="' + esc(img.src) + '" alt="">';
    zoom.addEventListener("click", function () {
      zoom.remove();
    });
    document.body.appendChild(zoom);
  });

  function setBusy(b) {
    busy = b;
    sendBtn.disabled = b;
    var typing = list.querySelector(".oa-typing");
    if (b && !typing) {
      typing = document.createElement("div");
      typing.className = "oa-typing";
      typing.textContent = "•••";
      list.appendChild(typing);
      settle();
    } else if (!b && typing) typing.remove();
  }

  // --- Panier (API AJAX de Shopify, dans le navigateur du client) ---
  function cartFetch(path, body) {
    return fetch(ROOT + path, {
      method: body ? "POST" : "GET",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: body ? JSON.stringify(body) : undefined,
      credentials: "same-origin",
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || "HTTP " + r.status);
        return j;
      });
    });
  }
  function readCart() {
    return cartFetch("/cart.js")
      .then(function (c) {
        return {
          currency: c.currency,
          total_price: c.total_price,
          items: (c.items || []).map(function (l) {
            return {
              key: l.key,
              id: l.variant_id,
              handle: l.handle,
              product_title: l.product_title,
              variant_title: l.variant_title,
              quantity: l.quantity,
              properties: l.properties || null,
              final_line_price: l.final_line_price,
            };
          }),
        };
      })
      .catch(function () {
        return null;
      });
  }
  function runActions(actions) {
    var chain = Promise.resolve();
    actions.forEach(function (a) {
      chain = chain.then(function () {
        if (a.type === "add") return cartFetch("/cart/add.js", { items: a.items });
        if (a.type === "change") {
          var body = { id: a.key, quantity: a.quantity };
          if (a.properties) body.properties = a.properties;
          return cartFetch("/cart/change.js", body);
        }
        if (a.type === "clear") return cartFetch("/cart/clear.js", {});
      });
    });
    return chain.then(refreshThemeCart);
  }
  // Rafraîchit l'icône et le tiroir du panier de Dawn sans recharger la page.
  function refreshThemeCart() {
    return fetch(ROOT + "/?sections=cart-icon-bubble,cart-drawer", { credentials: "same-origin" })
      .then(function (r) {
        return r.ok ? r.json() : {};
      })
      .then(function (sections) {
        var parse = function (html, selector) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var el = doc.querySelector(selector);
          return el ? el.innerHTML : null;
        };
        var bubble = document.getElementById("cart-icon-bubble");
        if (bubble && sections["cart-icon-bubble"]) {
          var b = parse(sections["cart-icon-bubble"], ".shopify-section");
          if (b !== null) bubble.innerHTML = b;
        }
        var drawer = document.getElementById("CartDrawer");
        if (drawer && sections["cart-drawer"]) {
          var d = parse(sections["cart-drawer"], "#CartDrawer");
          if (d !== null) drawer.innerHTML = d;
          var wrapper = document.querySelector("cart-drawer");
          if (wrapper) wrapper.classList.remove("is-empty");
        }
      })
      .catch(function () {});
  }
  function applyDiscount(code) {
    // Pose le code dans la session du panier; il s'applique à l'étape de livraison du paiement.
    return fetch(ROOT + "/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(ROOT + "/cart"), {
      credentials: "same-origin",
      redirect: "follow",
    }).catch(function () {});
  }

  // --- Transfert vers David dans Shopify Inbox ---
  // Inbox (<shopify-chat>) s'ouvre avec show(); sendStarterMessage() exige un clic du client,
  // d'où le bouton « Écrire à David ». Le résumé arrive dans Inbox comme premier message du client.
  function switchToInbox(resume) {
    state.handedOff = true;
    persist();
    document.documentElement.classList.add("oa-inbox");
    root.style.display = "none";
    var chat = document.querySelector("shopify-chat");
    if (!chat) {
      location.href = ROOT + (FR ? "/pages/contactez-nous" : "/pages/contact-us");
      return;
    }
    try {
      if (typeof chat.show === "function") chat.show();
      if (resume && typeof chat.sendStarterMessage === "function") {
        // Le résumé est écrit par l'assistant au nom du client, dans sa langue : le client le voit comme son message.
        var starter = resume + (FR ? " (transféré par l'assistant)" : " (handed over by the assistant)");
        chat.sendStarterMessage(starter.slice(0, 1000), "typed").catch(function () {});
      }
    } catch (e) {}
  }
  // Bouton « Écrire à David ». final = transfert décidé par l'assistant (on ne peut plus lui écrire);
  // sinon (panne passagère), le client peut aussi réessayer. Le transfert ne devient définitif qu'au clic.
  function openInbox(resume, final, replay) {
    if (!replay) {
      state.log.push({ k: "handoff", r: resume, f: !!final });
      persist();
    }
    var wrap = document.createElement("div");
    wrap.className = "oa-card";
    wrap.innerHTML =
      '<div class="oa-card-actions"><button type="button" class="oa-btn oa-btn-primary">' + esc(T.talk) + "</button></div>";
    list.appendChild(wrap);
    reveal(wrap, "card");
    if (final) {
      input.disabled = true;
      sendBtn.disabled = true;
    }
    wrap.querySelector("button").addEventListener("click", function () {
      switchToInbox(resume);
    });
  }

  // Après un changement de panier réussi : deux gros boutons bien visibles. Le petit lien du bas ne
  // suffisait pas (26 oct. 2026 : une cliente a attendu qu'on lui « montre son panier »).
  function showCartButtons(replay) {
    if (!replay) {
      state.log.push({ k: "cartbtns" });
      persist();
    }
    var wrap = document.createElement("div");
    wrap.className = "oa-card oa-card-cart";
    wrap.innerHTML =
      '<div class="oa-card-actions">' +
      '<a class="oa-btn oa-btn-secondary" href="' + esc(CFG.cartUrl || ROOT + "/cart") + '">' + esc(T.viewCart) + "</a>" +
      '<a class="oa-btn oa-btn-primary" href="' + esc(ROOT + "/checkout") + '">' + esc(T.checkout) + "</a></div>";
    list.appendChild(wrap);
    reveal(wrap, "card");
  }

  // --- Cartes de confirmation ---
  function showCard(pending, answered) {
    var card = document.createElement("div");
    card.className = "oa-card";
    card.innerHTML =
      '<div class="oa-card-title">' + esc(T.cardTitle) + "</div><ul>" +
      pending.summary.map(function (s) { return "<li>" + esc(s) + "</li>"; }).join("") + "</ul>" +
      (pending.notes && pending.notes.length ? '<div class="oa-card-notes">' + pending.notes.map(esc).join("<br>") + "</div>" : "") +
      '<div class="oa-card-actions"><button type="button" class="oa-btn oa-btn-primary">' + esc(T.confirm) + "</button>" +
      '<button type="button" class="oa-btn oa-btn-secondary">' + esc(T.decline) + "</button></div>";
    list.appendChild(card);
    reveal(card, "card");
    var yes = card.querySelector(".oa-btn-primary");
    var no = card.querySelector(".oa-btn-secondary");
    if (answered) {
      yes.disabled = no.disabled = true;
      return;
    }
    function answer(accepted) {
      if (busy) return;
      yes.disabled = no.disabled = true;
      setBusy(true);
      var p = accepted ? runActions(pending.actions).then(function () { return null; }, function (e) { return e.message || T.cartError; }) : Promise.resolve(null);
      p.then(function (error) {
        state.pending = null;
        state.log.push({ k: "card", p: pending, done: true });
        logAndShow("note", error ? T.cartError : accepted ? T.confirmed : T.declined);
        setAnchor(list.lastElementChild); // la réponse qui suit la carte reste sous « Confirmé. »
        return readCart().then(function (cart) {
          return send({ confirmation: { id: pending.id, accepted: accepted, error: error || undefined }, cart: cart });
        });
      });
    }
    yes.addEventListener("click", function () { answer(true); });
    no.addEventListener("click", function () { answer(false); });
  }

  // --- Tarifs de livraison du panier (vrais tarifs ClickShip, calculés par Shopify) ---
  // Le code postal part seulement vers Shopify (la boutique elle-même), comme au paiement.
  function runShippingTask(task) {
    setBusy(true);
    var a = task.address || {};
    var qs =
      "shipping_address%5Bzip%5D=" + encodeURIComponent(a.zip || "") +
      "&shipping_address%5Bcountry%5D=" + encodeURIComponent(a.country || "") +
      "&shipping_address%5Bprovince%5D=" + encodeURIComponent(a.province || "");
    return fetch(ROOT + "/cart/shipping_rates.json?" + qs, { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) {
            var msg = j && typeof j === "object" ? Object.keys(j).map(function (k) { return k + ": " + [].concat(j[k]).join(" "); }).join("; ") : "HTTP " + r.status;
            return { ok: false, error: msg };
          }
          return { ok: true, rates: (j && j.shipping_rates) || [] };
        });
      })
      .catch(function (e) {
        return { ok: false, error: String((e && e.message) || e) };
      })
      .then(function (res) {
        return readCart().then(function (cart) {
          return send({ taskResult: { id: task.id, ok: res.ok, rates: res.rates, error: res.error }, cart: cart });
        });
      });
  }

  // Le client écrit dans l'autre langue que la page : l'interface le suit (notes, boutons, champ, bulle).
  function switchLanguage(lang) {
    T = TEXTS[lang];
    state.uiLang = lang;
    persist();
    root.querySelector(".oa-header-sub").textContent = T.sub;
    root.querySelector(".oa-cart-link").textContent = T.cart;
    root.querySelector(".oa-privacy-link").textContent = T.privacy;
    input.placeholder = T.placeholder;
    sendBtn.setAttribute("aria-label", T.send);
    root.querySelector(".oa-close").setAttribute("aria-label", T.close);
    launcher.setAttribute("aria-label", T.open);
  }

  // --- Échange avec le serveur ---
  function send(extra) {
    setBusy(true);
    var body = {
      conversationId: state.conversationId,
      visitorId: visitorId,
      cart: extra.cart,
      page: { host: location.hostname, locale: CFG.locale || "" },
    };
    if (extra.message) body.message = extra.message;
    if (extra.confirmation) body.confirmation = extra.confirmation;
    if (extra.taskResult) body.taskResult = extra.taskResult;
    return fetch(CFG.endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json().then(function (j) {
          return { status: r.status, data: j };
        });
      })
      .then(function (res) {
        setBusy(false);
        var d = res.data || {};
        if (res.status === 429) return logAndShow("note", T.tooMany);
        if (res.status !== 200) {
          logAndShow("bot", T.error);
          return openInbox("", false);
        }
        state.conversationId = d.conversationId;
        state.lastAt = Date.now();
        if (d.lang && TEXTS[d.lang] && TEXTS[d.lang] !== T) switchLanguage(d.lang);
        persist();
        if (d.reply) logAndShow("bot", d.reply);
        var c = extra.confirmation;
        if (c && c.accepted && !c.error && !d.pending && extra.cart && extra.cart.items && extra.cart.items.length) {
          showCartButtons(false);
        }
        (d.actions || []).forEach(function (a) {
          if (a.type === "discount") applyDiscount(a.code);
          if (a.type === "handoff") {
            logAndShow("note", T.humanTitle);
            openInbox(a.resume, true);
          }
        });
        if (d.pending) {
          state.pending = d.pending;
          persist();
          showCard(d.pending, false);
        }
        if (d.task && d.task.type === "shipping_rates") return runShippingTask(d.task);
      })
      .catch(function () {
        setBusy(false);
        logAndShow("bot", T.error);
        openInbox("", false);
      });
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var text = input.value.trim();
    if (!text || busy) return;
    input.value = "";
    input.style.height = "";
    // Une carte encore ouverte n'est plus valable : le serveur l'annule en recevant ce message.
    var openCard = list.querySelectorAll(".oa-card .oa-btn:not(:disabled)");
    Array.prototype.forEach.call(openCard, function (b) { b.disabled = true; });
    if (state.pending) {
      state.log.push({ k: "card", p: state.pending, done: true });
      state.pending = null;
    }
    logAndShow("user", text);
    readCart().then(function (cart) {
      send({ message: text, cart: cart });
    });
  });
  input.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event("submit"));
    }
  });
  input.addEventListener("input", function () {
    input.style.height = "auto";
    input.style.height = Math.min(input.scrollHeight, 110) + "px";
  });

  // --- Démarrage : réafficher la conversation de la session ---
  function start() {
    if (state.handedOff) {
      document.documentElement.classList.add("oa-inbox");
      return;
    }
    document.body.appendChild(root);
    document.documentElement.classList.add("oa-active"); // cache Inbox, maintenant que l'assistant est là
    addBubble("bot", render(T.hello));
    state.log.forEach(function (entry) {
      if (entry.k === "card") showCard(entry.p, true);
      else if (entry.k === "handoff") openInbox(entry.r, entry.f, true);
      else if (entry.k === "cartbtns") showCartButtons(true);
      else if (entry.k === "note") addNote(entry.t);
      else addBubble(entry.k, entry.k === "user" ? esc(entry.t).replace(/\n/g, "<br>") : render(entry.t));
    });
    if (state.pending) showCard(state.pending, false);
    anchorEl = null;
    scrollDown();
    if (state.open) setOpen(true);
    scheduleTeaser();
  }

  // --- Bulle d'invitation : une fois par visite, jamais si le client a déjà ouvert le clavardage.
  // Le délai d'apparition court depuis l'ARRIVÉE sur le site (pas depuis chaque page), et la bulle reste
  // affichée 10 s au total, même si le client change de page entre-temps. Réglage du thème
  // « Afficher l'invitation » (CFG.teaser) pour la couper.
  var TEASER_VISIBLE_MS = 10000;
  function scheduleTeaser() {
    if (CFG.teaser === false || state.log.length || state.open) return;
    var t = load("sessionStorage", "oa-teaser") || {};
    if (t.closed) return;
    if (t.shownAt) {
      // Déjà apparue sur une page précédente : on la remontre pour le temps qui reste.
      var left = TEASER_VISIBLE_MS - (Date.now() - t.shownAt);
      if (left > 500) showTeaser(left, false);
      return;
    }
    var arrived = load("sessionStorage", "oa-arrived");
    if (!arrived) {
      arrived = Date.now();
      save("sessionStorage", "oa-arrived", arrived);
    }
    var wait = Math.max(1500, (Number(CFG.teaserDelay) || 5000) - (Date.now() - arrived));
    setTimeout(function () {
      if (state.open || root.classList.contains("oa-open")) return;
      var now = load("sessionStorage", "oa-teaser") || {};
      if (now.closed || now.shownAt) return;
      save("sessionStorage", "oa-teaser", { shownAt: Date.now() });
      showTeaser(TEASER_VISIBLE_MS, true);
    }, wait);
  }
  function showTeaser(duration, animate) {
    var t = document.createElement("div");
    t.className = "oa-teaser";
    if (!animate) t.style.animation = "none";
    t.setAttribute("role", "button");
    t.setAttribute("tabindex", "0");
    t.innerHTML =
      "<strong>" + esc(T.teaserTitle) + "</strong>" + esc(T.teaserText) +
      '<button type="button" class="oa-teaser-close" aria-label="' + esc(T.close) + '">&times;</button>';
    root.insertBefore(t, launcher);
    var timer = setTimeout(function () {
      t.remove();
    }, duration);
    // Fermée ou ouverte par le client : elle ne revient plus de la visite.
    var dismiss = function () {
      clearTimeout(timer);
      t.remove();
      save("sessionStorage", "oa-teaser", { closed: true });
    };
    t.querySelector(".oa-teaser-close").addEventListener("click", function (e) {
      e.stopPropagation();
      dismiss();
    });
    t.addEventListener("click", function () {
      dismiss();
      setOpen(true);
    });
    t.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        dismiss();
        setOpen(true);
      }
    });
    launcher.addEventListener("click", dismiss, { once: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
